const lowerCaseWords = [
    'de',
    'da',
    'do',
    'dos',
    'das',
    'para',
    'por',
    'com',
    'em',
    'na',
    'no',
    'nos',
    'pelo',
    'pela',
    'pelos',
    'pelas',
];
const uppercaseWords = [
    'ltda',
    'ac',
    'al',
    'ap',
    'am',
    'ba',
    'ce',
    'df',
    'es',
    'go',
    'ma',
    'mt',
    'ms',
    'mg',
    'pa',
    'pb',
    'pr',
    'pe',
    'pi',
    'rj',
    'rn',
    'rs',
    'ro',
    'rr',
    'sc',
    'sp',
    'se',
    'to',
];
const pascalize = (word) => (word[0]?.toUpperCase() || '') + word.slice(1);
export function toPascalCase(ignorePatterns) {
    const string = String(this || '');
    if (!string)
        return '';
    const pascalWords = string
        .toLowerCase()
        .split(' ')
        .map((word) => {
        if (ignorePatterns)
            return pascalize(word);
        if (lowerCaseWords.includes(word))
            return word;
        if (uppercaseWords.includes(word))
            return word?.toUpperCase();
        return pascalize(word);
    })
        .join(' ');
    return pascalWords;
}
//# sourceMappingURL=toPascalCase.js.map